import useSWR from "swr";
import { customFetcher } from "../../../../utils";
import { JobTitle } from "../../../../globals/interfaces";
import { useMemo } from "react";

export default function useJobTitles () {
    const {
        data,
        mutate
    } = useSWR('/job-title', customFetcher<JobTitle>, {
        fallbackData: []
    });

    const jobTitlesMap = useMemo(() => {
        const map: Record<string, string> = {};
        for (const { id, title } of data) {
            map[id] = title;
        }
        return map;
    }, [data]);

    return {
        data,
        mutate,
        jobTitlesMap
    }
}